import type { FaireProductEntity } from "../../entity_types/product";

export const p_22kbv319cc: FaireProductEntity = {
  token: "p_22kbv319cc",
  type: "product",
  name: "Postcard VA-360 Interior, Christ Church, Alexandria",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3412f866306c3d953bd8893d801ecce6629c677820c4873be754b8c14add70b3.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/86b13ddd2d895d90d0462020c91ce10e4715ab714b3c31f324f937a2a6f09bf5.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
